export const NUBE_KEYBOARD_ROUTES = {
  nubeKeyboard: '/nube-keyboard',
};
